import { cloneDeep } from 'lodash'
import { IAM, iam } from '@rhitics/core'
import AlertMixin from '@rhitics/vue/mixins/AlertMixin'

export default AlertMixin.extend({
  name: 'AccountMixin',

  data() {
    return {
      isLoading: false,
      user: {} as IAM.UserAggregate
    }
  },

  watch: {
    user: {
      handler(val) {
        this.$emit('update', val)
      },
      deep: true
    }
  },

  created() {
    this.user = cloneDeep(this.$auth.user)
  },

  methods: {
    async update() {
      this.resetAlert()
      try {
        this.isLoading = true
        const user = cloneDeep(this.user)!
        const res = await iam.user.updateV2(user)
        // @ts-ignore
        this.$auth.setUser(res.data)
        this.showAlert(this.$t('core.alert.update_success').toString(), 'success')

        window.location.reload()
      } catch (err: any) {
        this.showAlert(this.$t('core.alert.update_failed').toString(), 'error')
      } finally {
        this.isLoading = false
      }
    }
  }
})
